<template>
  <div>
    <div class="mb3">
      <label @click="add('method')" for="methods" class="label block col-12 h6 left-align">METHODS</label>
      <div @keyup.space="add('method')" id="methods" tabindex="0" class="input p1 col-12 left-align h6">
        <span class="h6">{{ methodList }}&ensp;</span><span @click="add('method')" class="pointer gray h6">✎&nbsp;&nbsp;Add Methods</span>
      </div>
    </div>
    <div class="mb3">
      <label @click="add('keyword')" for="keys" class="label block col-12 h6 left-align">KEYWORDS</label>
      <div @keyup.space="add('keyword')" id="keys" tabindex="0" class="input p1 col-12 left-align h6">
        <span class="h6">{{ keywordList }}&ensp;</span><span @click="add('keyword')" class="pointer gray h6">✎&nbsp;&nbsp;Add Keywords</span>
      </div>
    </div>
    <div class="mb3">
      <label @click="add('folksonomy')" for="tags" class="label block col-12 h6 left-align">TAGS</label>
      <div @keyup.space="add('keyword')" id="tags" tabindex="0" class="input p1 col-12 left-align h6">
        <span class="h6">{{ folksonomyList }}&ensp;</span><span @click="add('folksonomy')" class="pointer gray h6">✎&nbsp;&nbsp;Add Tags</span>
      </div>
    </div>

    <!-- modal -->
    <transition name="custom-classes-transition" enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
      <tag-list v-if="addTag" @close="addTag = null" :tag-type="addTag" :title="tagTypes[addTag]" :list="lists[addTag]" :placeholder="placeholders[addTag]" :editable="editable"/>
    </transition>
  </div>
</template>

<script>
  import TagList from '@/components/TagList'

  const editsAllowed = ['folksonomy']

  export default {
    name: 'Taxonomies',
    props: {
      lists: {
        type: Object,
        default () {
          return {
            method: [],
            keyword: [],
            folksonomy: []
          }
        }
      }
    },
    data () {
      return {
        addTag: null,
        tagTypes: {
          'method': 'Add Methods',
          'keyword': 'Add Keywords',
          'folksonomy': 'Add Tags'
        },
        placeholders: {
          method: 'Type here to search Methods',
          keyword: 'Type here to search Keywords',
          folksonomy: 'Type here to search or add a new Tag'
        }
      }
    },
    computed: {
      methodList () {
        return this.lists.method.map(m => m.name).join(', ')
      },
      keywordList () {
        return this.lists.keyword.map(k => k.name).join(', ')
      },
      folksonomyList () {
        return this.lists.folksonomy.map(f => f.name).join(', ')
      },
      editable () {
        return editsAllowed.includes(this.addTag)
      }
    },
    methods: {
      add (type) {
        this.addTag = type
      },
      check ({ code, keyCode }, type) {
        if ([code, keyCode].includes(32)) {
          this.add(type)
        }
      }
    },
    components: { TagList }
  }
</script>
